import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./style.scss";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { getCommonApi } from "redux/actions/common";

export class TabClass extends Component {
  state = {
    activeTab: null,
    navLinks: [
      {
        to: "/admin/reportsmenu",
        label: "Uncategorized Reports",
        role: ["1", "2", "3"],
        rightskey: "flgquantum",
      },
      {
        to: "/admin/reportsettings",
        label: "Settings ",
        role: ["1", "2", "3"],

        rightskey: "flgquantum",
      },
    ],
  };

  componentDidMount() {
    const currentActiveTab = this.getCurrentActiveTab();

    this.setState({ activeTab: currentActiveTab });
  }

  updateState = (data) => {
    if (this.state.isMounthed) this.setState(data);
  };

  componentWillUnmount() {
    this.state.isMounthed = false;
  }

  getCurrentActiveTab = () => {
    const currentUrl = window.location.pathname;

    if (currentUrl === "/admin/reportsmenu") {
      return 0;
    } else if (currentUrl === "/admin/backend/inventory") {
      return 1;
    }
  };
  handleTabClick = (event, tab) => {
    this.setState({
      activeTab: tab,
    });
  };

  render() {
    let {
      menu,

      navLinks,
    } = this.state;

    return (
      <header className="header">
        <div className="site-header">
          <nav className="navbar navbar-expand-lg navbar-expand-md  navbar-light bg-white navbar-border pl-0">
            <div
              style={menu ? { display: "block" } : { display: "none" }}
              className={`collapse navbar-collapse navbar-menu`}
              id="navbar-menu"
            >
              <ul className="navbar-nav position-relative ml-auto p-lg-0">
                <li className="ipad-sidebar nav-item pl-2">
                  {navLinks.map(
                    ({ to, label, role, imgno, rightskey }, index) => (
                      <div key={index}>
                        <Link className="text-decoration-none" to={to}>
                          <button
                            className={
                              this.state.activeTab === index
                                ? "active"
                                : "ipad-sidebar-elements"
                            }
                            onClick={(event) =>
                              this.handleTabClick(event, index)
                            }
                          >
                            {label}
                          </button>
                        </Link>
                      </div>
                    )
                  )}
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
    },
    dispatch
  );
};

let component = TabClass;

export const Tab = connect(mapStateToProps, mapDispatchToProps)(component);
